import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface DetialRequest {
    list_no: string;
}

export interface DetailResponse {
    statusCode: number;
    message: string;
    data: {
        w_date: string;
        accept_no: number;
        f_gubun: string;
        f_company: string;
        f_name: string;
        f_tel: string;
        f_post: string;
        f_address1: string;
        f_address2: string;
        f_date1: string;
        f_date2: string;
        f_time: string;
        t_city: string;
        t_sudan: string;
        t_cnt: string;
        t_pickup: string;
        t_weight: string;
        t_memo: string;
        pickup_id: string;
        branch: string;
        sms: string;
        result: number;
        result_text: string;
    };
}

export const useGetConsoleAirPickupDetail = ({ list_no }: DetialRequest): UseQueryResult<DetailResponse, Error> => {
    let url = enum_api_uri.get_console_air_pickup_detail.replace(":list_no", list_no);
    return useQuery({
        queryKey: ["useGetConsoleAirPickupDetail", list_no],
        queryFn: async () => {
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
        enabled: !!list_no,
    });
};
